import React from 'react'
import moment from 'moment'
import UserCourseCalendar from '../../user/course-calendar'

const EmptyDayMessage = () => {
    return (
        <div>
            <div className='text-center'>
                <h3>You currently have no experiences on this day.</h3>
            </div>
            <div className='text-center'>
                Enroll in a new experience below.
            </div>
        </div>
    )
}

const ScheduleCalendar = ({
    userId
}) => {
    const [ dateSelected, setDateSelected ] = React.useState(moment())

    return (
        <div style={{ paddingTop: '10px' }}>
            <UserCourseCalendar
                userId={userId}
                date={dateSelected}
                onDateChange={setDateSelected}
                emptyDayMessage={(<EmptyDayMessage />)}
            />
        </div>
    )
}

export default ScheduleCalendar